var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createSelector } from 'reselect';
import { initialState } from './reducer';
export var selectAppAdmins = function (state) { return state.appAdmins || initialState; };
export var makeAppAdminList = function () {
    return createSelector(selectAppAdmins, function (pageState) {
        var result = __assign({}, pageState);
        return result;
    });
};
